module.exports = __webpack_public_path__ + "img/六门控制器 (5).e1fd1bce.jpg";